/**
 * Optional card shell: overflow clip + frost strip + children.
 * Frost is on by default here (this shell exists for frost); pass `enabled={false}` to opt out.
 * Prefer `CardFrostStrip` inside existing card Views for lists (one less wrapper).
 */
import React, { memo } from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { Card } from 'tamagui';
import CardFrostStrip, { frostParentClipStyle, type CardFrostStripProps } from './CardFrostStrip';

type FrostedCardProps = CardFrostStripProps & {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** Use Tamagui Card as shell (default: plain View). */
  asTamagui?: boolean;
};

const FrostedCard = memo(function FrostedCard({
  children,
  style,
  asTamagui = false,
  tone,
  colors,
  theme,
  height,
  compact,
  enabled = true,
}: FrostedCardProps) {
  const stripProps = { tone, colors, theme, height, compact, enabled };

  if (asTamagui) {
    return (
      <Card overflow="hidden" style={[frostParentClipStyle, style] as any}>
        <CardFrostStrip {...stripProps} />
        {children}
      </Card>
    );
  }

  return (
    <View style={[frostParentClipStyle, style]}>
      <CardFrostStrip {...stripProps} />
      {children}
    </View>
  );
});

export default FrostedCard;
